import React from 'react'
import { Navigate } from 'react-router-dom'
import { getAccess } from '../../../helpers/ReduxHelpers'
import { defaultWorkspacePath } from '../constants'

/**
 * D2CLanding — entry point for /d2c-pricing. Reads the JWT accessList and
 * redirects to the correct workspace (FH → L1 → SL), per the integration guide's
 * tab-routing rule. Wrapped by MultiRoleProtectedRoute so only D2C users reach it.
 */
export default function D2CLanding() {
  return <Navigate to={defaultWorkspacePath(getAccess())} replace />
}
